import React from 'react';
import PropTypes from 'prop-types';
import { handleKeyPress } from '../audioPlayerHelper';

const ResetButton = ({ onReset }) => {
    const handleRefreshKeyPress = event => {
        handleKeyPress(event, () => onReset());
    };

    return (
        <i
            role="button"
            aria-label="button"
            tabIndex="0"
            className="icon-v2-replay"
            onKeyPress={handleRefreshKeyPress}
            onClick={onReset}
        />
    );
};

ResetButton.defaultProps = {
    onReset: () => {},
};

ResetButton.propTypes = {
    onReset: PropTypes.func,
};

export default ResetButton;
